const retailDeletedPage = require('./retailDeleted-page')
const retailDeletedDt = require('./retailDeleted-dt')
const retailDeletedFullcont = require('./retailDeleted-fullcont')

export function start(detail) {
      const component = components[detail.elem]

      if (component) { component.start(detail) }
}

const components = {
      page: { start: (detail) => { retailDeletedPage.start(detail) } },
      dt: { start: (detail) => { retailDeletedDt.start(detail) } },
      fullcont: { start: (detail) => { retailDeletedFullcont.start(detail) } },
}
